// textAreaFormControl theme styles place the field label on the left and the
// character count on the right (same layout as Description).
export const FIELD_FORM_CONTROL_CLASS = 'textAreaFormControl';

export const SINGLE_LINE_INPUT_SX = {
  '& .MuiInputBase-root': {
    minHeight: '40px',
    alignItems: 'center'
  },
  '& .MuiInputBase-input': {
    height: '40px',
    boxSizing: 'border-box'
  },
  // textAreaFormControl absolutely positions status icons; keep adornment icons
  // inline for single-line OutlinedInput fields.
  '& .MuiInputAdornment-root': {
    alignSelf: 'center'
  },
  '& .MuiInputAdornment-root .MuiSvgIcon-root': {
    position: 'static'
  }
};
